/** Created by razial on 16.02.2026. */

const EditorPointerView = cc.Node.extend({ 
    ctor: function (pointer) {
        this._super();

        this.pointer = pointer;

        const styles = cleverapps.styles.EditorPointerView;

        const dot = new cc.DrawNode();
        dot.drawDot(cc.p(0, 0), styles.dot.radius, cc.color(255, 80, 80, 200));
        this.addChild(dot);

        const label = cleverapps.UI.generateOnlyText(pointer.userId, cleverapps.styles.FONTS.EDITOR_POINTER_LABEL);
        label.setAnchorPoint(0, 0.5);
        label.setPosition(styles.label.dx, styles.label.dy);
        this.addChild(label);

        this.updatePosition();

        pointer.on("updatePosition", this.updatePosition.bind(this), this);
    },

    updatePosition: function () {
        this.setPosition(this.pointer.x, this.pointer.y);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    EDITOR_POINTER_LABEL: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        font: bundles.chat.urls.strict_font_ttf,
        stroke: {
            size: 2,
            color: cleverapps.styles.COLORS.BLACK
        }
    }
});

cleverapps.styles.EditorPointerView = {
    dot: {
        radius: 8
    },
    label: {
        dx: 14,
        dy: 14
    }
};
